<template lang="pug">
  a.mypage-button-box(v-bind:href="href")
    div.mypage-button
    div.icon-text {{ buttonName }}
</template>
<script>
import CustomerStore from '../../../stores/CustomerStore'

export default {
  name: 'MypageButton',
  /**
   * data
   * @returns {{msg: string}}
   */
  data () {
    return {
    }
  },
  /**
   * mounted
   */
  mounted () {
    CustomerStore.dispatch('loadCustomer')
  },
  computed: {
    /**
     * ボタン名を返す
     * @return {string}
     */
    buttonName () {
      return CustomerStore.state.buttonName
    },
    /**
     * computed
     */
    href () {
      return this.login ? '/mypage' : '/mypage/login'
    },
    /**
     * ログイン済みかどうか
     * @returns {boolean} ログイン情報
     */
    login () {
      return CustomerStore.state.user.login
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../../../assets/scss/bootstrap/bootstrap.scss';
.mypage-button-box {
  text-decoration: none !important;
}
.mypage-button {
  display: block;
  background: url('../../../../static/images/common/header_login.gif') no-repeat;
  background-size: 27px 27px;
  background-position: center 8px;
  height: 42px;
}
.icon-text {
  font-family: “HiraginoSans-W5”, sans-serif;
  text-align: center;
  font-size: 8px;
  text-decoration: none;
  letter-spacing: -0.1em;
  color: #929292;
}
</style>



// WEBPACK FOOTER //
// src/components/sp/common/MypageButton.vue